<template>
    <h1>PAGINA DE INICIO</h1>
</template>